import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePickerInput from "../../share/input/DatePicker";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnAlternative, BtnPrimary } from "../../share/buttons/Btn";
import MessageQuill from "../Message/MessageQuill";
import { ReactComponent as Upload } from "../../../Assets/Image/svg/Upload.svg";
import useFetch from "../../../Hooks/useFetch";
import moment from "jalali-moment";
import { useCreate } from "../../../Context/CreateContext";
import { Modal } from "../../share/modal/Modal";
import DragAndDropCourse from "./DragAndDropCourse";

const AddSessionCourse = ({
    close,
    status,
    setStatus,
    id,
    setId,
    getSessions,
    state,
    sessionInfo,
}) => {
    //const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [call, setCall] = useState();
    const [uploadCall, setUploadCall] = useState();
    const [file, setFile] = useState();
    const [uploadedFiles, setUploadedFiles] = useState();
    const [uploadedHomeWorks, setUploadedHomeWorks] = useState();
    const [description, setDescription] = useState();
    const [upload, setUpload] = useState(false);
    const [session, setSession] = useState({
        id: "",
        session_name: "",
        session_start_time: "",
        session_end_time: "",
        session_description: "",
    });

    const handleModalClose = (e) => {
        e.stopPropagation();
        close(false);
        setSession({
            id: "",
            session_name: "",
            session_start_time: "",
            session_end_time: "",
            session_description: "",
        });
        //setUploadedFiles();
        //setStatus(false);
        setStart("");
        setEnd("");
        setId("");
    };

    const handleModal = () => {
        setUpload(!upload);
    };

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        setSession({
            ...session,
            session_start_time: moment(
                start,
                "HH:mm:ss jYYYY/jMM/jDD"
            ).format(),
        });
    }, [start]);

    useEffect(() => {
        setSession({
            ...session,
            session_end_time: moment(end, "HH:mm:ss jYYYY/jMM/jDD").format(),
        });
    }, [end]);

    useEffect(() => {
        setSession({ ...session, session_description: description });
    }, [description]);

    const submitForm = () => {
        if (id) {
            console.log("edit");
            editSession.reFetch();
            if (file) {
                const fileData = new FormData();
                fileData.append("bootcamp_session", id);
                fileData.append("file", file[0]);
                setUploadCall(fileData);
                uploadSessionFile.reFetch();
            }

            close();
        } else {
            const formData = new FormData();

            formData.append("bootcamp", 11);
            //TODO : id bootcamp dynamic she
            formData.append("session_name", session.session_name);
            formData.append("session_start_time", session.session_start_time);
            formData.append("session_end_time", session.session_end_time);
            formData.append("session_description", description);

            setCall(formData);
            newSession.reFetch();

            setSession({
                id: "",
                session_name: "",
                session_start_time: "",
                session_end_time: "",
                session_description: "",
            });

            setStart();
            setEnd();

            close();
        }
    };

    useEffect(() => {
        if (id) {
            setStart(
                moment(session.session_start_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );

            setEnd(
                moment(session.session_end_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );
        }
    }, [session]);

    const newSession = useFetch({
        method: "POST",
        url: `BootCampSessionService`,
        noHeader: false,
        caller: getSessions,
        trigger: false,
        data: call,
    });

    const getSessionsId = useFetch({
        method: "GET",
        url: `BootCampSessionService/${id}`,
        noHeader: false,
        trigger: false,
        setter: setSession,
    });

    const getSessionFiles = useFetch({
        method: "GET",
        url: `BootCampSessionFilesService/${id}/session_files`,
        noHeader: false,
        trigger: false,
        setter: setUploadedFiles,
    });

    const editSession = useFetch({
        method: "PATCH",
        url: `BootCampSessionService/${id}`,
        noHeader: false,
        trigger: false,
        caller: getSessions,
        data: session,
    });

    const uploadSessionFile = useFetch({
        method: "POST",
        url: `BootCampSessionFilesService`,
        noHeader: false,
        trigger: false,
        caller: getSessions,
        data: uploadCall,
    });

    useEffect(() => {
        if (id) {
            getSessionsId.reFetch();
            getSessionFiles.reFetch();
        }
    }, [id]);

    return (
        <div className="AddnewsupportTicket relative max-w-3xl">
            <button
                onClick={handleModalClose}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-20">
                {status ? "اطلاعات تکلیف" : "اطلاعات جلسه"}
            </h3>
            <form onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    value={session.session_name}
                    onChange={(e) =>
                        setSession({ session_name: e.target.value })
                    }
                    type="text"
                    name="name"
                    control={control}
                    placeholder="نام جلسه*"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] input"
                />
                <div className="flex justify-around gap-8 mb-[1.6rem]">
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        defaultValue={start}
                        setDate={setStart}
                        message="زمان شروع جلسه را وارد کنید"
                        placeholder={
                            status ? "زمان شروع تکلیف" : "زمان شروع جلسه"
                        }
                        full={true}
                        name="catch_start_date"
                        control={control}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        defaultValue={end}
                        setDate={setEnd}
                        message={"زمان پایان را وارد کنید"}
                        placeholder={
                            status ? "زمان پایان تکلیف" : "زمان پایان جلسه"
                        }
                        full={true}
                        name="catch_end_date"
                        control={control}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                </div>

                <MessageQuill
                    placeholder="توضیحات *"
                    value={session.session_description}
                    setValue={setDescription}
                />
                {state === "edit" ? (
                    <div className="flex justify-center ">
                        <div
                            className=" w-1/2 py-[15px] px-[25px] flex border-gray border-[1px] text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] justify-between cursor-pointer"
                            onClick={() => {
                                setUpload(!upload);
                                getSessionFiles.reFetch();
                            }}
                        >
                            <span>بارگزاری فایل</span>
                            <Upload />
                        </div>
                        <BtnPrimary
                            className=" py-[2rem] px-[6rem] flex justify-center items-center mr-auto "
                            text={`ثبت ${status ? "تکلیف" : "جلسه"}`}
                        />
                    </div>
                ) : (
                    <BtnPrimary
                        className=" py-[2rem] px-[6rem] flex justify-center items-center mr-auto "
                        text={`ثبت ${status ? "تکلیف" : "جلسه"}`}
                    />
                )}
            </form>
            {uploadedFiles?.results.length !== 0 && (
                <div className="mt-10 max-w-3xl">
                    <h3 className="text-3xl mb-10">فایلهای آپلود شده :</h3>
                    <div className="flex flex-col text-2xl justify-start gap-y-8 mb-[1.6rem]">
                        {uploadedFiles?.results.map(() => (
                            <div>Session File Test</div>
                        ))}
                    </div>
                </div>
            )}

            <Modal show={upload} closeModal={handleModal}>
                <DragAndDropCourse
                    uploadFile
                    sessions
                    sessionInfo={sessionInfo}
                    uploadedFiles={uploadedFiles}
                    setFile={setFile}
                    close={handleModal}
                    label=""
                    {...register("photo", { required: false })}
                    //message="رزومه خود را انتخاب کنید"
                    error={errors["photo"]}
                    accept=".png , .jpg, .mp4, .pdf, .mp3, .docx"
                    //id="cover_upload"
                    type="image"
                />
            </Modal>
        </div>
    );
};

export default AddSessionCourse;
